import {BaseModel} from "./BaseModel";

export class MessageModel extends BaseModel {
    constructor(cookie = "") {
        super();
        this.cookie = cookie;

    }

    RouteName = "Message";
    AuthState = true;

    getAllWithPaginate(pageNumber, pageSize = 10) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .get(
                    `${this.RouteName}/page?pageNumber=${pageNumber}&pageSize=${pageSize}`
                );
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    SendMessage(model) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .post(
                    `${this.RouteName}/SendMessage`, model)
                ;
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    ToggleRead(id) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .post(
                    `${this.RouteName}/ToggleRead?id=${id}`)
                ;
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    GetAllMsgPeople() {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .get(
                    `${this.RouteName}/GetAllMsgPeople`
                );
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    async GetSearch(Username = "",
                    Role = "",
                    AzSabt = "",
                    TaSabt = "",
                    Vaziat = "",
    ) {
        try {

            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .get(`${this.RouteName}/search?Username=${Username}&Role=${Role}&AzSabt=${AzSabt}&TaSabt=${TaSabt}&Vaziat=${Vaziat}`)
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }


}
